export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 50;
export const STICKY_TABLE_HEADER_HEIGHT = '3rem';
export const STICKY_TABLE_FILTER_ROW_HEIGHT = '2.75rem';
export const STICKY_TABLE_FILTER_ROW_TOP = STICKY_TABLE_HEADER_HEIGHT;
export const STICKY_TABLE_APPLIED_FILTERS_ROW_TOP = `calc(${STICKY_TABLE_HEADER_HEIGHT} + ${STICKY_TABLE_FILTER_ROW_HEIGHT})`;
export const FILTER_DEBOUNCE_MS = 300;
